import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iGetKinaseOffTargetState {
    response: any;
    isLoading: boolean;
    message: string;
}

const initialState: iGetKinaseOffTargetState = {
    response: [],
    isLoading: false,
    message: ""
};
export const getKinaseOffTargetAPI = createAsyncThunk(
    "GET_KINASE_OFF_TARGET",
    async (params: { entry_name: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = `/data/kinase-inhibitor/off-target-rank/?kinase_name=${encodeURIComponent(params.entry_name)}`;
            
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

export const kinaseOffTargetSlice = createSlice({
    name: "kinaseOffTarget",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getKinaseOffTargetAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(getKinaseOffTargetAPI.fulfilled, (state, action) => {
                state.response = action.payload;
                state.isLoading = false;
            })
            .addCase(getKinaseOffTargetAPI.rejected, (state) => {
                state.isLoading = false;
                state.message = "error";
            });
    }
});

export default kinaseOffTargetSlice.reducer;